// Centralized backend URL resolver.
// Some production builds were accidentally compiled with REACT_APP_BACKEND_URL
// pointing to the static frontend host (loveconnectplus.fr) which has NO backend,
// causing "Failed to fetch". This resolver detects that case (or an empty value)
// and falls back to the fixed production backend.
const PRODUCTION_BACKEND = "https://monetize-messages.emergent.host";
const STATIC_HOSTS = ["loveconnectplus.fr", "www.loveconnectplus.fr"];

function resolveBackendUrl() {
  const configured = process.env.REACT_APP_BACKEND_URL || "";
  if (!configured) return PRODUCTION_BACKEND;
  try {
    const host = new URL(configured).hostname;
    if (STATIC_HOSTS.includes(host)) return PRODUCTION_BACKEND;
  } catch (e) {
    return PRODUCTION_BACKEND;
  }
  return configured;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
